import WebsiteConfig from "./WebsiteConfig";

export { WebsiteConfig };
